function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import $ from 'jquery';
import WDHCarouselStack from './wdh-carousel-stack';
import { onLoad, onResize, onEvent, onScroll, WDHComponent } from '../../../../wdh-foundation/wdh';
var _window = window,
    DGS = _window.DGS;
/**
 * Carousel - The carousel component will wrap contiguous components with the same class name (default: carousel-slide) together to create a carousel of components.
 * @author JTTO
 * @memberOf WDHCarousel
 */

var WDHCarousel = /*#__PURE__*/function (_WDHComponent) {
  _inherits(WDHCarousel, _WDHComponent);

  var _super = _createSuper(WDHCarousel);

  /**
   * @constructor
   * @param {string} [className=carousel-slide] className - the class name for the components which should be grouped together as a single carousel.
   */
  function WDHCarousel() {
    var _this;

    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'carousel-slide';

    _classCallCheck(this, WDHCarousel);

    _this = _super.call(this, className);
    /**
     * @private
     * @type {boolean}
     */

    _this.inEditMode = document.body ? document.body.classList.contains('mode-editing') : false;
    /**
     * options for the Carousel
     * @type {Object} options
     * @type {boolean} [false] options.slideOnMobile - whether the component should be displayed as a carousel object on mobile.
     * @type {number} [5000] options.slideInterval - the length of time in milliseconds that the current slide of the carousel should display for before switching.
     * @type {boolean} [false] options.sliderTabsBelow - whether to place the dot navigation bar below the entire carousel
     */

    _this.options = {
      slideOnMobile: false,
      hasRestrictedSlides: false,
      restrictedSlideClass: '',
      slideInterval: 5000,
      sliderTabsBelow: false
    };
    /**
     * @private
     * @type {string}
     */

    _this.slideOnMobileClass = 'banner-carousel-slide-on-mobile';
    /**
     * @private
     * @type {string}
     */

    _this.slideNavigationBelowClass = 'banner-carousel-tabs-below';
    _this.stacks = [];
    return _this;
  }
  /**
   * function to set our default options for the carousel
   * @param options {object}
   */


  _createClass(WDHCarousel, [{
    key: "setOptions",
    value: function setOptions(options) {
      if (_typeof(options) === 'object') {
        var tempOptions = Object.assign({}, this.options, options);
        this.options = tempOptions;
      }
    }
    /**
     * loops through all components on the page and builds a carousel out of all components with the className defined in the constructor.
     * overrides WDHComponent run() method.
     */

  }, {
    key: "run",
    value: function run() {
      var _this2 = this;

      onLoad(function () {
        _this2.initSlideshow();
      });
    }
  }, {
    key: "initSlideshow",
    value: function initSlideshow() {
      var _this3 = this;

      var group = null; // set groupOptions to our defaults

      var groupOptions = Object.assign({}, this.options); // loop through all components on the screen to determine if they are a slider-stack.

      $('.component').each(function (index, element) {
        var $this = $(element);

        if ($this.hasClass(_this3.className)) {
          // check if designer added the banner-carousel-slide-on-mobile class to any element in our stack. If so, apply it to the entire stack
          if (!groupOptions.slideOnMobile) {
            groupOptions = Object.assign(groupOptions, {
              slideOnMobile: $this.hasClass(_this3.slideOnMobileClass)
            });
          } // check if we want the navigation dots to be below the slides


          if (!groupOptions.sliderTabsBelow) {
            groupOptions = Object.assign(groupOptions, {
              sliderTabsBelow: $this.hasClass(_this3.slideNavigationBelowClass)
            });
          }

          if (!group) {
            group = $this;
          } else {
            group = $.merge(group, $this);
          }
        } else {
          if (group) {
            _this3.setupGroup(group, groupOptions); // reset our group options so that additional carousels can work independently.


            groupOptions = Object.assign({}, _this3.options);
          }

          group = null;
        }
      });

      if (group) {
        this.setupGroup(group, groupOptions); // reset our group options so that additional carousels can work independently.

        groupOptions = Object.assign({}, this.options);
      }
    }
    /**
     * initializes all components on the page that were grouped together as a single Carousel object.
     * @param {jQuery} group - group of DOM elements that have the default carousel className.
     * @param groupOptions - custom options for the carousel object
     */

  }, {
    key: "setupGroup",
    value: function setupGroup(group, groupOptions) {
      if (this.inEditMode) {
        group.each(function (index, element) {
          $(element).addClass('slide-index');
          $(element).attr('data-index', "slide : ".concat(index + 1));
        });
      } // Build each carousel component.


      var stack = new WDHCarouselStack(group);
      this.stacks.push(stack);
      groupOptions = Object.assign({
        editMode: this.inEditMode
      }, groupOptions);
      stack.setOptions(groupOptions);
      stack.init();
      this.components.push(stack.getInstance()); // returns the node for the carousel wrapper.

      onResize(function () {
        onEvent(DGS.Events.RESIZE_DONE, function () {
          stack.resize();
        });
      });
      onScroll(function (scrollTop) {
        stack.onScroll(scrollTop);
      });
    }
    /**
     * resets stack with new options.
     * @param options {Object} options object
     * @param target {string} optional classname to target individual stacks
     */

  }, {
    key: "resetStack",
    value: function resetStack(options) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var targets = this.stacks;

      if (target !== '') {
        targets = this.stacks.filter(function (stack) {
          return $(stack.slides).hasClass(target);
        });
      }

      targets.forEach(function (stack) {
        stack.setOptions(options);
        stack.run(true);
      });
    }
  }]);

  return WDHCarousel;
}(WDHComponent);

export default WDHCarousel;